module.exports = __webpack_public_path__ + "img/img2.4cd238fb.jpg";